import DefaultHomeModule from './containers/defaultHomeModule'

export {default as DefaultHomeModuleLayout} from './components/defaultHomeModuleLayout'

export default DefaultHomeModule
